import API from '../../shared/Config/API';
import APIEndpoints from '../../shared/Config/APIEndpoints';

const getCPCBLog = async () => {
  try {
    return await API.get(APIEndpoints.CPCB_LOGS, null);
  } catch (error) {
    console.error(error);
  }
};

export const downTimeAPI = {
  getCPCBLog,
};
